export const i18nConfig = {
  defaultLocale: "en",
  locales: ["ja", "ja-JP", "en", "en-US", "zh", "zh-CN"],
} as const;

export type Language = (typeof i18nConfig)["locales"][number];
